export const routeNamesForClientSearch = [
  'planner',
  'client-detail',
  'feedback'
]

export const feedbackDataType = [
  'needed',
  'provided',
  'combine'
]

export const savedFavPropertyType = [
  'favorites',
  'toured'
]

export const DEFAULT_CONFIRMATION_MODAL_VALUE = {
  status: false,
  message: null,
  positive: null,
  negative: null
}
